__turbopack_context__.v({
  "allTabContent": "SearchView-module-scss-module__Hgr-gq__allTabContent",
  "container": "SearchView-module-scss-module__Hgr-gq__container",
  "content": "SearchView-module-scss-module__Hgr-gq__content",
  "dropdown": "SearchView-module-scss-module__Hgr-gq__dropdown",
  "emptyMessage": "SearchView-module-scss-module__Hgr-gq__emptyMessage",
  "emptyState": "SearchView-module-scss-module__Hgr-gq__emptyState",
  "filtersInner": "SearchView-module-scss-module__Hgr-gq__filtersInner",
  "filtersWrapper": "SearchView-module-scss-module__Hgr-gq__filtersWrapper",
  "foundBanner": "SearchView-module-scss-module__Hgr-gq__foundBanner",
  "foundText": "SearchView-module-scss-module__Hgr-gq__foundText",
  "header": "SearchView-module-scss-module__Hgr-gq__header",
  "pagination": "SearchView-module-scss-module__Hgr-gq__pagination",
  "paginationInfo": "SearchView-module-scss-module__Hgr-gq__paginationInfo",
  "productGrid": "SearchView-module-scss-module__Hgr-gq__productGrid",
  "searchColumn": "SearchView-module-scss-module__Hgr-gq__searchColumn",
  "searchContainer": "SearchView-module-scss-module__Hgr-gq__searchContainer",
  "searchLabel": "SearchView-module-scss-module__Hgr-gq__searchLabel",
  "sectionBanner": "SearchView-module-scss-module__Hgr-gq__sectionBanner",
  "showMoreWrapper": "SearchView-module-scss-module__Hgr-gq__showMoreWrapper",
  "storesGrid": "SearchView-module-scss-module__Hgr-gq__storesGrid",
  "summary": "SearchView-module-scss-module__Hgr-gq__summary",
  "tabs": "SearchView-module-scss-module__Hgr-gq__tabs",
  "title": "SearchView-module-scss-module__Hgr-gq__title",
});
